import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

const DEFAULT_OVERLAY_Z_INDEX = 21_000;

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="overlay" *ngIf="isLoading" [style.z-index]="overlayZIndex">
      <div class="spinner-container" [class.large-desktop]="largeOnDesktop">
        <div class="circle-spinner"></div>
      </div>
      <div class="loading-text">{{ text || 'Loading…' }}</div>
    </div>
  `,
  styles: [`
    .overlay { 
      position: fixed; 
      inset: 0; 
      background: rgba(255, 255, 255, 0.4); 
      display: flex; 
      flex-direction: column; 
      align-items: center; 
      justify-content: center; 
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
    }

    .spinner-container {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
    }

    .circle-spinner {
      width: 48px;
      height: 48px;
      border: 4px solid #E7E7E7;
      border-top-color: #5D89E9;
      border-radius: 50%;
      animation: spin 0.9s linear infinite;
    }

    .loading-text { 
      margin-top: 0;
      font-family: Lato, Arial, sans-serif; 
      font-weight: 600; 
      font-size: 16px; 
      color: #2A2A2A; 
      letter-spacing: 0.5px;
      z-index: 1;
      position: relative;
    }

    @keyframes spin { 
      from { transform: rotate(0deg); } 
      to { transform: rotate(360deg); } 
    }

    @media (max-width: 600px) {
      .circle-spinner {
        width: 40px;
        height: 40px;
        border-width: 3px;
      }
    }

    @media (min-width: 768px) {
      .circle-spinner {
        width: 48px;
        height: 48px;
        border-width: 4px;
      }
      .spinner-container.large-desktop .circle-spinner {
        width: 64px;
        height: 64px;
        border-width: 5px;
      }
    }
  `]
})
export class LoadingSpinnerComponent {
  @Input() isLoading: boolean = false;
  @Input() text: string = 'Loading…';
  @Input() largeOnDesktop: boolean = false;
  /** Stacking order for the full-viewport overlay (above passport dropdowns and desktop header). */
  @Input() overlayZIndex: number = DEFAULT_OVERLAY_Z_INDEX;
}

